/**
 * Environment configuration for the webapp
 * Uses runtime configuration from window.APP_CONFIG when available,
 * falling back to Vite's import.meta.env for local development
 */

// Get runtime config from window object (set by public/config.js)
const getRuntimeConfig = (): Partial<{
	apiBaseUrl: string;
	graphqlUrl: string;
	workosClientId: string;
}> => {
	if (typeof window !== "undefined" && window.APP_CONFIG) {
		return window.APP_CONFIG;
	}
	return {};
};

export const config = {
	// API Configuration - prefer runtime config, fallback to build-time env vars
	apiBaseUrl:
		getRuntimeConfig().apiBaseUrl ||
		import.meta.env.VITE_API_BASE_URL ||
		"http://localhost:3000",
	graphqlUrl:
		getRuntimeConfig().graphqlUrl ||
		import.meta.env.VITE_GRAPHQL_URL ||
		"http://localhost:3000/graphql",

	// WorkOS Configuration
	workosClientId:
		getRuntimeConfig().workosClientId || import.meta.env.WORKOS_CLIENT_ID,

	// Environment info
	isDevelopment: import.meta.env.DEV,
	isProduction: import.meta.env.PROD,
	mode: import.meta.env.MODE,
} as const;

// Type safety for environment variables
declare global {
	interface ImportMetaEnv {
		readonly VITE_API_BASE_URL: string;
		readonly VITE_GRAPHQL_URL: string;
		readonly WORKOS_CLIENT_ID: string;
	}

	interface Window {
		APP_CONFIG?: {
			apiBaseUrl: string;
			graphqlUrl: string;
			workosClientId: string;
		};
	}
}
